import { render, staticRenderFns } from "./ItineraryPaquete.vue?vue&type=template&id=6b95887c"
import script from "./ItineraryPaquete.vue?vue&type=script&lang=js"
export * from "./ItineraryPaquete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports